module.exports = __webpack_public_path__ + "img/payment-btn-bg.f1f952b2.png";